/* eslint-disable react/prop-types */
import React, { Component } from "react";
import Navbar from "react-bootstrap/lib/Navbar";
import Nav from "react-bootstrap/lib/Nav";
import NavItem from "react-bootstrap/lib/NavItem";
import NavDropdown from "react-bootstrap/lib/NavDropdown";
import MenuItem from "react-bootstrap/lib/MenuItem";
import { withRouter } from "react-router-dom";
import { Icon, Image, Flag, Dimmer, Loader } from "semantic-ui-react";
import { connect } from "react-redux";
import {
  tsExpertAction,
  configAction,
  // ----------------------- Protocol ----------------------------
  protocolResumeAction,
  protocolLivelistAction,
  protocolLiveListMatrixAction,
  protocolGraphicTopologyAction,
  protocolLogAction,
  // ----------------------- Optic Fiber ----------------------------
  opticFiberAction,
  OpticFiberLogAction,
  // ----------------------- Physical Medium DP ----------------------------
  dpLiveListAction,
  dpLiveListMatrixAction,
  dpOscilloscopeAction,
  dpBarGraphAction,
  dpLogAction
} from "actions/changeActiveItemActions";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();

class BootstrapMenuBar extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      dropdownTitle: Strings.MONITORING,
      monitoringStyle: { display: "block" },
      olmStyle: { display: "none" },
      oscilloscopeStyle: { display: "none" },
      languageKey: localStorage.getItem(Constants.LOCAL_STORAGE_KEY),
      language: UtilsInstance.getLanguageStringFromKey(
        Constants,
        Strings),
      isUpdatingLanguageDimmerActive: false
    };
  }

  setMenuBarCurrentState = () => {
    const currentPath = this.props.history.location.pathname;
    const isFiberProcessOn = sessionStorage.getItem("isFiberProcessOn") === "true";

    if (isFiberProcessOn) {
      if (currentPath.includes("/optic-fiber")) {
        this.setState({
          dropdownTitle: Strings.OPTIC_FIBER,
          monitoringStyle: { 
            display: "none" 
          },
          oscilloscopeStyle: {
            display: "none"
          },
          olmStyle: { 
            display: "block" 
          }
        });
      } 
      else if (currentPath.includes("/dp-")) {
        this.setState({
          dropdownTitle: Strings.PHYS_MEDIUM,
          monitoringStyle: {
            display: "none"
          },
          oscilloscopeStyle: {
            display: "block"
          },
          olmStyle: { 
            display: "none" 
          }
        });
      }
      else {
        this.setState({
          dropdownTitle: Strings.MONITORING,
          monitoringStyle: {
            display: "block"
          },
          oscilloscopeStyle: {
            display: "none"
          },
          olmStyle: { 
            display: "none" 
          }
        });
      }
    } else {
      if (currentPath.includes("/dp-")) {
        this.setState({
          dropdownTitle: Strings.PHYS_MEDIUM,
          monitoringStyle: {
            display: "none"
          },
          oscilloscopeStyle: {
            display: "block"
          },
          olmStyle: { 
            display: "none" 
          }
        });
      }
      else {
        this.setState({
          dropdownTitle: Strings.MONITORING,
          monitoringStyle: {
            display: "block"
          },
          oscilloscopeStyle: {
            display: "none"
          },
          olmStyle: { 
            display: "none" 
          }
        });
      }
    }
  }

  handleSelect = (eventKey) => {
    switch (eventKey) {
      // ----------------------- TS Expert ----------------------------
      case "/":
        this.props.onChangeTSExpert();
        this.props.history.push("/");
        break;
      // ----------------------- Protocol ----------------------------
      case "/protocol-resume":
        this.props.onChangeProtocolResume();
        this.props.history.push("/protocol-resume");
        break;
      case "/protocol-livelist":
        this.props.onChangeProtocolLiveList();
        this.props.history.push("/protocol-livelist");
        break;
      case "/protocol-livelist-matrix":
        this.props.onChangeProtocolLiveListMatrix();
        this.props.history.push("/protocol-livelist-matrix");
        break;
      case "/protocol-graphic-topology":
        this.props.onChangeProtocolGraphicTopology();
        this.props.history.push("/protocol-graphic-topology");
        break;
      case "/protocol-log":
        this.props.onChangeProtocolLog();
        this.props.history.push("/protocol-log");
        break;
      // ----------------------- Optic Fiber ----------------------------
      case "/optic-fiber":
        this.props.onChangeOpticFiber();
        this.props.history.push("/optic-fiber");
        break;
      case "/optic-fiber-log":
        this.props.onChangeOpticFiberLog();
        this.props.history.push("/optic-fiber-log");
        break;
      // ----------------------- Physical Medium DP ----------------------------
      case "/dp-live-list":
        this.props.onChangeDpLiveList();
        this.props.history.push("/dp-live-list");
        break;
      case "/dp-live-list-matrix":
        this.props.onChangeDpLiveListMatrix();
        this.props.history.push("/dp-live-list-matrix");
        break;
      case "/dp-oscilloscope":
        this.props.onChangeDpOscilloscope();
        this.props.history.push("/dp-oscilloscope");
        break;
      case "/dp-bar-graph":
        this.props.onChangeDpBarGraph();
        this.props.history.push("/dp-bar-graph");
        break;
      case "/dp-log":
        this.props.onChangeDpLog();
        this.props.history.push("/dp-log");
        break;
      // ----------------------- Config ----------------------------
      case "/config":
        this.props.onChangeConfig();
        this.props.history.push("/login-handler");
        break;
      default:
        break;
    }
  }

  handleDropdownSelect = (eventKey) => {
    const isFiberProcessOn = sessionStorage.getItem("isFiberProcessOn") === "true";

    if (isFiberProcessOn) {
      if (eventKey === "/drop-mon") {
        this.setState({
          dropdownTitle: Strings.MONITORING,
          monitoringStyle: {
            display: "block"
          },
          oscilloscopeStyle: {
            display: "none"
          },
          olmStyle: {
            display: "none"
          }
        }, () => {
          this.handleSelect("/protocol-resume");
        });
      }
      else if (eventKey === "/drop-osc") {
        this.setState({
          dropdownTitle: Strings.PHYS_MEDIUM,
          monitoringStyle: {
            display: "none"
          },
          oscilloscopeStyle: {
            display: "block"
          },
          olmStyle: {
            display: "none"
          }
        }, () => {
          this.handleSelect("/dp-live-list");
        });
      }
      else if (eventKey === "/drop-opticFiber") {
        this.setState({
          dropdownTitle: Strings.OPTIC_FIBER,
          monitoringStyle: {
            display: "none"
          },
          oscilloscopeStyle: {
            display: "none"
          },
          olmStyle: {
            display: "block"
          }
        }, () => {
          this.handleSelect("/optic-fiber");
        });
      }
    } else {
      if (eventKey === "/drop-mon") {
        this.setState({
          dropdownTitle: Strings.MONITORING,
          monitoringStyle: {
            display: "block"
          },
          oscilloscopeStyle: {
            display: "none"
          },
          olmStyle: {
            display: "none"
          }
        }, () => {
          this.handleSelect("/protocol-resume");
        });
      }
      else if (eventKey === "/drop-osc") {
        this.setState({
          dropdownTitle: Strings.PHYS_MEDIUM,
          monitoringStyle: {
            display: "none"
          },
          oscilloscopeStyle: {
            display: "block"
          },
          olmStyle: {
            display: "none"
          }
        }, () => {
          this.handleSelect("/dp-live-list");
        });
      }
    }
  }

  handleLanguageChange = (lang) => {
    this.sendLanguageData(lang);
  }

  sendLanguageData = (lang) => {
    this.setState({ isUpdatingLanguageDimmerActive: true }, () => {

      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "language_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify({ language: lang })
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          localStorage.setItem(Constants.LOCAL_STORAGE_KEY, lang);
          window.location.reload();
        })
        .catch((error) => {
          alert(Strings.UNABLE_TO_ALTER_LANGUAGE + Strings.REASON_DP + error);
        })
        .finally(this.setState({ isUpdatingLanguageDimmerActive: false }));
    });
  }

  getOpticFiberNav = (activeItem) => {
    if (sessionStorage.getItem("isFiberProcessOn") === "true") {
      return (
        <Nav style={this.state.monitoringStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
          <NavItem
            style={fontStyle}
            eventKey='/optic-fiber'
            active={activeItem === "/optic-fiber"}>
            {Strings.OPTIC_FIBER}
          </NavItem>
        </Nav>
      );
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.setMenuBarCurrentState();
  }

  render() {
    let activePage = { "activeItem": "/" + this.props.location.pathname.split("/")[1] };
    const isFiberProcessOn = sessionStorage.getItem("isFiberProcessOn") === "true";

    if (activePage.activeItem === "/login" || activePage.activeItem === "/login-handler") {
      activePage.activeItem = "/config";
    }

    const { activeItem } = activePage;

    return (
      <>
        <Navbar fluid defaultExpanded inverse collapseOnSelect style={menuStyle}>
          <Navbar.Header>
            <Navbar.Brand>
              <Image
                src="./logo.png"
                alt="TS Monitor Logo"
                as="button"
                style={noBorderStyle}
                size="tiny"
                onClick={() => {
                  this.handleSelect("/");
                }}
              />
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>

          <Navbar.Collapse>

            <Nav pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/"
                active={activeItem === "/"}>
                {Strings.TS_EXPERT}
              </NavItem>
            </Nav>

            <Nav pullLeft bsStyle="pills" onSelect={k => this.handleDropdownSelect(k)}>
              <NavDropdown id="nav-drop" style={fontStyle} title={this.state.dropdownTitle}>
                <MenuItem eventKey="/drop-mon">{Strings.MONITORING}</MenuItem>
                <MenuItem eventKey="/drop-osc">{Strings.PHYS_MEDIUM}</MenuItem>
                {isFiberProcessOn && (<MenuItem eventKey="/drop-opticFiber">{Strings.OPTIC_FIBER}</MenuItem>)}
              </NavDropdown>
            </Nav>

            {/* ------------------------------- Protocolo ------------------------------- */}
            <Nav style={this.state.monitoringStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/protocol-resume"
                active={activeItem === "/protocol-resume"}>
                {Strings.RESUME}
              </NavItem>
            </Nav>

            <Nav style={this.state.monitoringStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey='/protocol-livelist'
                active={activeItem === "/protocol-livelist"}>
                {Strings.LIVE_LIST}
              </NavItem>
            </Nav>

            <Nav style={this.state.monitoringStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey='/protocol-livelist-matrix'
                active={activeItem === "/protocol-livelist-matrix"}>
                {Strings.MATRIX}
              </NavItem>
            </Nav>

            <Nav style={this.state.monitoringStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey='/protocol-graphic-topology'
                active={activeItem === "/protocol-graphic-topology"}>
                {Strings.GRAPHIC_TOPOLOGY}
              </NavItem>
            </Nav>

            <Nav style={this.state.monitoringStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey='/protocol-log'
                active={activeItem === "/protocol-log"}>
                {Strings.LOG}
              </NavItem>
            </Nav>

            {isFiberProcessOn && (
              <Nav style={this.state.olmStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
                <NavItem
                  style={fontStyle}
                  eventKey="/optic-fiber"
                  active={activeItem === "/optic-fiber"}>
                  {Strings.OPTIC_FIBER}
                </NavItem>
              </Nav>
            )}

            {isFiberProcessOn && (
              <Nav style={this.state.olmStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
                <NavItem
                  style={fontStyle}
                  eventKey="/optic-fiber-log"
                  active={activeItem === "/optic-fiber-log"}>
                  {Strings.LOG}
                </NavItem>
              </Nav>
            )}

            {/* ------------------------------- Physical Medium DP ------------------------------- */}
            <Nav style={this.state.oscilloscopeStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/dp-live-list"
                active={activeItem === "/dp-live-list"}>
                {Strings.LIVE_LIST}
              </NavItem>
            </Nav>

            <Nav style={this.state.oscilloscopeStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/dp-live-list-matrix"
                active={activeItem === "/dp-live-list-matrix"}>
                {Strings.MATRIX}
              </NavItem>
            </Nav>

            <Nav style={this.state.oscilloscopeStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/dp-oscilloscope"
                active={activeItem === "/dp-oscilloscope"}>
                {Strings.OSCILLOSCOPE}
              </NavItem>
            </Nav>

            <Nav style={this.state.oscilloscopeStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/dp-bar-graph"
                active={activeItem === "/dp-bar-graph"}>
                {Strings.BAR_GRAPH}
              </NavItem>
            </Nav>

            <Nav style={this.state.oscilloscopeStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey='/dp-log'
                active={activeItem === "/dp-log"}>
                {Strings.LOG}
              </NavItem>
            </Nav>

            <Nav pullRight bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>

              <NavDropdown
                role="menuitem"
                id="language-dropdown"
                eventKey={this.state.languageKey}
                title={this.state.language}
                onSelect={lang => this.handleLanguageChange(lang)}>

                <MenuItem
                  eventKey="pt">
                  <Flag name="br" />
                  {Strings.PORTUGUESE}
                </MenuItem>

                <MenuItem
                  eventKey="en">
                  <Flag name="us" />
                  {Strings.ENGLISH}
                </MenuItem>

                <MenuItem
                  eventKey="es">
                  <Flag name="es" />
                  {Strings.SPANISH}
                </MenuItem>

                {/* <MenuItem
                  eventKey="de">
                  <Flag name="de" />
                  {Strings.GERMAN}
                </MenuItem> */}

              </NavDropdown>

              <NavItem
                style={fontStyle}
                eventKey='/config'
                active={activeItem === "/config"}>
                <Icon name="cog" />
                {Strings.CONFIG_STRING}
              </NavItem>
            </Nav>
          </Navbar.Collapse>

        </Navbar >
        <Dimmer page active={this.state.isUpdatingLanguageDimmerActive} >
          <Loader size="big">{Strings.UPDATING_LANGUAGE_WAITING}</Loader>
        </Dimmer>
      </>
    );
  }
}

const mapStateToProps = state => ({
  active: state.activeMenuItem
});

const mapActionsToProps = {
  onChangeTSExpert: tsExpertAction,
  onChangeConfig: configAction,
  // ----------------------- Protocol ----------------------------
  onChangeProtocolResume: protocolResumeAction,
  onChangeProtocolLiveList: protocolLivelistAction,
  onChangeProtocolLiveListMatrix: protocolLiveListMatrixAction,
  onChangeProtocolGraphicTopology: protocolGraphicTopologyAction,
  onChangeProtocolLog: protocolLogAction,
  // ----------------------- Optic Fiber ----------------------------
  onChangeOpticFiber: opticFiberAction,
  onChangeOpticFiberLog: OpticFiberLogAction,
  // ----------------------- Physical Medium DP ----------------------------
  onChangeDpLiveList: dpLiveListAction,
  onChangeDpLiveListMatrix: dpLiveListMatrixAction,
  onChangeDpOscilloscope: dpOscilloscopeAction,
  onChangeDpBarGraph: dpBarGraphAction,
  onChangeDpLog: dpLogAction,
};

const menuStyle = {
  backgroundColor: "#262626",
  padding: "8pt",
  borderRadius: "0pt",
  borderWidth: 0
};

const fontStyle = {
  fontSize: "medium"
};

const noBorderStyle = {
  border: "none",
  background: "none",
  marginTop: "-4pt",
};

export default connect(mapStateToProps, mapActionsToProps)(withRouter(BootstrapMenuBar));
